import { defineComponent, onMounted, onUnmounted } from 'vue';
import DashboardPreviewModalCode from '@/presentation/components/dashboard-preview-modal/dashboard-preview-modal.code';

export default defineComponent({
	setup: () => {
		const code = new DashboardPreviewModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			carouselIndex: code.carouselIndex,
			amountOfCarouselSlides: code.amountOfCarouselSlides,
			modalContent: code.modalContent,
			dashboardName: code.dashboardName,
			dashboardDescriptionParagraphs: code.dashboardDescriptionParagraphs,
			dashboardKeyResearchQuestions: code.dashboardKeyResearchQuestions,
			isModalStateOverview: code.isModalStateOverview,
			isModalStateCarousel: code.isModalStateCarousel,
			retrieveCarouselImageUrl: code.retrieveCarouselImageUrl.bind(code),
			openCarousel: code.openCarousel.bind(code),
			moveCarouselForward: code.moveCarouselForward.bind(code),
			moveCarouselBackward: code.moveCarouselBackward.bind(code),
			moveCarouselToIndex: code.moveCarouselToIndex.bind(code),
			shouldModalBeClosed: code.shouldModalBeClosed.bind(code),
			handleRequestDemoClick: code.handleRequestDemoClick.bind(code)
		};
	}
});
